import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { UIContext } from "../../contexts/UIContext";
import { Button } from "../../Theme/Hyper";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import { HeartRateContext } from "../../contexts/HeartRateContext";

const TeamNamePanel = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1em;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  height: 7vh;
`;
const Team = styled.div`
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  display: flex;
  width: 40%;
  align-items: center;
  height: 54px;
`;
const Middle = styled.div`
  display: flex;
  width: 20%;
  justify-content: space-evenly;
  align-items: center;
  margin-top: -10px;
`;
const TeamName = styled.div`
  padding-left: ${(props) => (props.home ? "0.5em" : "")};
  margin-left: ${(props) => (props.home ? "auto" : "")};
  display: flex;
  font-size: 1.5em;
  cursor: pointer;
`;
const Score = styled.div`
  display: flex;
  font-size: 4em;
  width: 100%;
  justify-content: center;
  cursor: pointer;
  border-radius: 2px;
  :hover {
    background-color: #db0a41;
  }
`;
const TeamButton = styled(Button)`
  background-color: ${(props) => (props.selected ? "#14ec8e" : "")};
  color: ${(props) => (props.selected ? "#000" : "")};
`;
export default function TeamNames({ setGoalScored, game, setSelectedPlayer }) {
  const { setView, selectedTeam, setGoal, teamSides } = useContext(UIContext);
  const { previewGraphic, updateGraphic } = useContext(GraphicsContext);
  let homeBGColour =
    game.home_team?.variables?.[game?.home_team_kit + "_kit_bg"] || "";
  let awayBGColour =
    game.away_team?.variables?.[game?.away_team_kit + "_kit_bg"] || "";

  return (
    <>
      <TeamNamePanel>
        <Team
          style={{
            borderBottom:
              "3px solid " + (homeBGColour ? homeBGColour : "rgba(0,0,0,0)"),
            opacity:
              !selectedTeam || selectedTeam._id === game.home_team._id
                ? "1"
                : ".2",
          }}
        >
          <div>{game.home_formation?.name}</div>
          <TeamName home>{game.home_team?.name}</TeamName>
        </Team>
        <Middle>
          <Score
            onContextMenu={(e) => {
              e.preventDefault();
            }}
          >
            {game?.home_scorers?.filter((g) => g.game === 1)?.length || 0}
          </Score>
          -
          <Score
            right
            onContextMenu={(e) => {
              e.preventDefault();
            }}
          >
            {game?.away_scorers?.filter((g) => g.game === 1)?.length || 0}
          </Score>
          <Score
            onContextMenu={(e) => {
              e.preventDefault();
            }}
          >
            {game?.home_scorers?.filter((g) => g.game === 2)?.length || 0}
          </Score>
          -
          <Score
            right
            onContextMenu={(e) => {
              e.preventDefault();
            }}
          >
            {game?.away_scorers?.filter((g) => g.game === 2)?.length || 0}
          </Score>
        </Middle>
        <Team
          style={{
            borderBottom:
              "3px solid " + (awayBGColour ? awayBGColour : "rgba(0,0,0,0)"),
            opacity:
              !selectedTeam || selectedTeam._id === game.away_team._id
                ? "1"
                : ".2",
          }}
        >
          <TeamName
          // onClick={() => {
          //   if (selectedTeam && selectedTeam._id === game.away_team._id) {
          //     setSelectedTeam();
          //     setView(VIEW_CONSTS.live);
          //   } else {
          //     setSelectedTeam(game.away_team);
          //     if (view === VIEW_CONSTS.live) {
          //       setView(VIEW_CONSTS.formation);
          //     }
          //   }
          // }}
          >
            {game.away_team?.name}
          </TeamName>
          <div style={{ marginLeft: "auto" }}>{game.away_formation?.name}</div>
        </Team>
      </TeamNamePanel>
      <TeamToggle game={game} />
      <GameGraphics
        previewGraphic={previewGraphic}
        game={game}
        teamSides={teamSides}
      />
      <TeamGraphics
        teamSides={teamSides}
        previewGraphic={previewGraphic}
        game={game}
        updateGraphic={updateGraphic}
      />
    </>
  );
}

function TeamToggle({ previewGraphic, game }) {
  const { teamSides, setTeamSides } = useContext(UIContext);

  return (
    <TeamNamePanel>
      <TeamButton
        style={{ marginLeft: "5px" }}
        selected={teamSides === 0}
        onClick={() => {
          setTeamSides(0);
        }}
      >
        {game?.home_team?.name} - {game?.away_team?.name}
      </TeamButton>
      <TeamButton
        style={{ marginLeft: "5px" }}
        selected={teamSides === 1}
        onClick={() => {
          setTeamSides(1);
        }}
      >
        {game?.away_team?.name} - {game?.home_team?.name}
      </TeamButton>
    </TeamNamePanel>
  );
}

function GameGraphics({ previewGraphic, game, teamSides }) {
  return (
    <TeamNamePanel>
      <Button
        style={{ marginLeft: "5px" }}
        onClick={() => {
          previewGraphic("MatchScore", {
            game,
            game_num: 1,
            half: 1,
            teamSides,
          });
        }}
      >
        Game 1 HT
      </Button>
      <Button
        style={{ marginLeft: "5px" }}
        onClick={() => {
          previewGraphic("MatchScore", {
            game,
            game_num: 1,
            half: 2,
            teamSides,
          });
        }}
      >
        Game 1 FT
      </Button>
      <Button
        style={{ marginLeft: "5px" }}
        onClick={() => {
          previewGraphic("MatchStats", {
            game,
            game_num: 1,
            half: 1,
            teamSides,
          });
        }}
      >
        Game 1 HT Match Stats
      </Button>
      <Button
        style={{ marginLeft: "5px" }}
        onClick={() => {
          previewGraphic("MatchStats", {
            game,
            game_num: 1,
            half: 2,
            teamSides,
          });
        }}
      >
        Game 1 FT Match Stats
      </Button>
      <Button
        style={{ marginLeft: "5px" }}
        onClick={() => {
          previewGraphic("MatchStats", {
            game,
            game_num: 1,
            half: 0,
            teamSides,
          });
        }}
      >
        Game 1 Live Match Stats
      </Button>
      <Button
        style={{ marginLeft: "50px" }}
        onClick={() => {
          previewGraphic("MatchScore", {
            game,
            game_num: 2,
            half: 1,
            teamSides,
          });
        }}
      >
        Game 2 HT
      </Button>
      <Button
        style={{ marginLeft: "5px" }}
        onClick={() => {
          previewGraphic("MatchScore", {
            game,
            game_num: 2,
            half: 2,
            teamSides,
          });
        }}
      >
        Game 2 FT
      </Button>
      <Button
        style={{ marginLeft: "5px" }}
        onClick={() => {
          previewGraphic("MatchStats", {
            game,
            game_num: 2,
            half: 1,
            teamSides,
          });
        }}
      >
        Game 2 HT Match Stats
      </Button>
      <Button
        style={{ marginLeft: "5px" }}
        onClick={() => {
          previewGraphic("MatchStats", {
            game,
            game_num: 2,
            half: 2,
            teamSides,
          });
        }}
      >
        Game 2 FT Match Stats
      </Button>
      <Button
        style={{ marginLeft: "5px" }}
        onClick={() => {
          previewGraphic("MatchStats", {
            game,
            game_num: 2,
            half: 0,
            teamSides,
          });
        }}
      >
        Game 2 Live Match Stats
      </Button>
    </TeamNamePanel>
  );
}

function TeamGraphics({ previewGraphic, updateGraphic, game, teamSides }) {
  const { data: hrData } = useContext(HeartRateContext);
  const [gameNum, setGameNum] = useState(1);
  useEffect(() => {
    if (hrData && game) {
      updateGraphic("FFHeartRate", {
        rates: hrData,
        game: game,
        game_num: gameNum,
        teamSides,
      });
    }
  }, [hrData, gameNum, game, teamSides]);

  return (
    <TeamNamePanel>
      <Button
        style={{ marginLeft: "10px" }}
        onClick={() => {
          setGameNum(1);

          previewGraphic("FFHeartRate", {
            game,
            game_num: 1,
            teamSides,
          });
        }}
      >
        Game 1 Heart Rate
      </Button>
      <Button
        style={{ marginLeft: "5px" }}
        onClick={() => {
          previewGraphic("TeamStats", {
            team: game?.home_team,
            lineup: game?.lineup?.home,
            stats: game?.fifa_home_stats,
            teamSides,
          });
        }}
      >
        {game?.home_team?.name} Team Stats
      </Button>

      <Button
        style={{ marginLeft: "5px" }}
        onClick={() => {
          previewGraphic("TeamStats", {
            team: game?.away_team,
            lineup: game?.lineup?.away,
            stats: game?.fifa_away_stats,
            teamSides,
          });
        }}
      >
        {game?.away_team?.name} Team Stats
      </Button>

      <Button
        style={{ marginLeft: "10px" }}
        onClick={() => {
          setGameNum(2);

          previewGraphic("FFHeartRate", {
            game,
            game_num: 2,
            teamSides,
          });
        }}
      >
        Game 2 Heart Rate
      </Button>
      <Button
        style={{ marginLeft: "5px" }}
        onClick={() => {
          previewGraphic("Champions", {
            team: game?.home_team,
            lineup: game?.lineup?.home,
            stats: game?.fifa_home_stats,
            teamSides,
          });
        }}
      >
        {game?.home_team?.name} Champions
      </Button>
      <Button
        style={{ marginLeft: "5px" }}
        onClick={() => {
          previewGraphic("Champions", {
            team: game?.away_team,
            lineup: game?.lineup?.away,
            stats: game?.fifa_away_stats,
            teamSides,
          });
        }}
      >
        {game?.away_team?.name} Champions
      </Button>
    </TeamNamePanel>
  );
}
